import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { MainLayout } from '../../layouts/MainLayout';
import { OverviewLayout } from '../../componentsv2/screens/OverviewLayout';
import { AuthGuard } from '../../componentsv2/misc/AuthGuard';
import { services } from '../../services';
import { utils } from '../../utils';
import { useUser } from '../../contexts/UserContext';
import { useCommittedOrganization } from '../../session/OrganizationIdentityContext';
import { acquireOperationContext } from '../../session/operation';

const DashboardPage = () => {
  const { user } = useUser();
  const router = useRouter();
  const currentOrganization = useCommittedOrganization();

  useEffect(() => {
    if (
      user !== null &&
      user?.permissions &&
      !(services.user.userHasScope(user, 'organization:read') || services.user.userHasScope(user, 'organizations:read')) &&
      !utils.authUtils.isAcendaStaff()
    ) {
      const operation = acquireOperationContext(currentOrganization);
      if (operation.isScopeCurrent()) void router.push(`/${currentOrganization}/items`);
    }
  }, [currentOrganization, router, user]);

  // Check if user can access dashboard
  const canAccessDashboard =
    ((user && (services.user.userHasScope(user, 'organization:read') || services.user.userHasScope(user, 'organizations:read'))) ||
      utils.authUtils.isAcendaStaff()) &&
    currentOrganization;

  return <>{canAccessDashboard ? <OverviewLayout key={currentOrganization} /> : <div>Loading or no access...</div>}</>;
};

DashboardPage.getLayout = (page: React.ReactElement) => (
  <AuthGuard>
    <MainLayout>{page}</MainLayout>
  </AuthGuard>
);

export default DashboardPage;
